import { useEffect } from "react";
import { useHistory } from "react-router";

interface ForwardProps {
  path: string;
}

export default function Forward(props: ForwardProps) {
  const history = useHistory();

  useEffect(() => {
    history.push(props.path);
  });

  return <div />;
}
